import { supabase } from "../supabaseClient";
import { lookupByName } from "../utils";

export function useLookupByName() {
  return {
    lookupByName: (q) => lookupByName(q, supabase),
  };
}
